export default __webpack_public_path__ + "static/media/faq.68906fea.png";